<script setup>
import { ref, watch } from "vue";
import { ElMessage } from "element-plus";
import axios from "axios";
import { fileUploadApi } from "@/api/common";

const emits = defineEmits(["fileUpload"]);

const props = defineProps({
  url: {
    type: String,
  },
});

// 图片url
const imageUrl = ref("");

// 禁用文件上传
const uploadDisabled = ref(false);

const uploadRef = ref(null);

const fileTypes = ref(["png", "jpg", "jpeg"]);

const fileChange = (file) => {
  const suffix = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);
  if (!fileTypes.value.includes(suffix)) {
    return ElMessage.error(
      `文件格式不正确, 请上传${fileTypes.value.join("/")}图片格式文件!`
    );
  }
  const fileData = new FormData();
  imageUrl.value = window.URL.createObjectURL(file.raw);
  fileData.append("file", file.raw);
  fileUploadApi(fileData).then((res) => {
    if (res.code == "2000") {
      emits("fileUpload", {
        reduceUrl: res.data.reduceUrl,
        originalName: res.data.originalName,
      });
    }
  });
  uploadDisabled.value = true;
};

const handleRemove = () => {
  uploadRef.value?.clearFiles();
  imageUrl.value = "";
  uploadDisabled.value = false;
  emits("fileUpload", {
    reduceUrl: "",
  });
};

// 文件预览
const filePreview = (reduceUrl) => {
  axios
    .post("/api/operate/file/preview", { reduceUrl }, { responseType: "blob" })
    .then((res) => {
      imageUrl.value = window.URL.createObjectURL(res.data);
    });
};

watch(
  () => props.url,
  (newVal, oldVal) => {
    if (newVal) {
      filePreview(newVal);
      uploadDisabled.value = true;
    } else {
      imageUrl.value = "";
      uploadDisabled.value = false;
    }
  },
  { immediate: true }
);
</script>

<template>
  <div>
    <el-upload
      ref="uploadRef"
      class="avatar-uploader"
      action=""
      :show-file-list="false"
      :auto-upload="false"
      :on-change="fileChange"
      :disabled="uploadDisabled"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>
    <el-icon v-if="imageUrl" style="cursor: pointer" @click="handleRemove()"
      ><Delete
    /></el-icon>
  </div>
</template>

<style lang="scss" scoped>
.avatar-uploader {
  width: 178px;
  height: 178px;
  display: block;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: 0.2;
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}

.avatar-uploader:hover {
  border-color: #409eff;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>
